import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { WebMainLayoutDefaultParam, WebMainParam } from '@module/apis/client-side/main/type';

export const mainQueryKeys = createQueryKeys('main', {
  fetchWebMainPage: (params: WebMainParam) => [params],
  fetchWebMainInfo: (params?: WebMainLayoutDefaultParam) => ['fetchWebMainInfo', params],
  fetchBjHome: () => ['fetchBjHome'],
  fetchMobileMainInfo: (params: WebMainParam) => [params],
});
